import { render, staticRenderFns } from "./build-note.vue?vue&type=template&id=f52a85d0&"
import script from "./build-note.vue?vue&type=script&lang=js&"
export * from "./build-note.vue?vue&type=script&lang=js&"
import style0 from "./build-note.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports